export default __webpack_public_path__ + "static/media/federated-portal-admin-user.3f70e27a.svg";